exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".numero[data-v-279c5228]{font-size:14px;padding-top:3px;padding-bottom:3px;width:27px;border-radius:20px}.gris[data-v-279c5228]{color:#7a7a7a}.textcuenta[data-v-279c5228]{font-weight:700}.is-select[data-v-279c5228]{color:#00d1b2;font-size:23px}.is-error[data-v-279c5228]{color:#ff3860}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-279c5228","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registrar/Viewregistro.vue
// module id = 507
// module chunks = 0